import script from "./ModalExito.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalExito.vue?vue&type=script&setup=true&lang=js"

import "./ModalExito.vue?vue&type=style&index=0&id=1d69eb09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d69eb09"]])

export default __exports__